import { document } from '../globals';

const stickyHeaderObserver = (): void => {
  const triggerElement = document?.querySelector('[data-sticky-trigger]');

  if (!triggerElement) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        document?.body?.classList.toggle(
          'has-sticky',
          entry.intersectionRatio < 1,
        );
      });
    },
    { threshold: [1] },
  );

  observer.observe(triggerElement);
};

export default stickyHeaderObserver;
